import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './LoginPage/LoginPage';
import Workers from './Sanay3yaView/DashboardView';
import FactoryManagerView from './ModeerView/FactoryManagerDashboard';
import SalesView from './SalesView/SalesDashboardView';
import CompanyManagerView from './CompanyManagerView/CompanyManagerDashboardView';
import ProductManagement from './ProductManagement/ProductManagement';
import ProductsInventory from './ProductsInventory/ProductInventoryView';
import RequestsManagement from './Requests/RequestsManagement';
import CreateNewProduct from './CreateProduct/CreateNewProduct';
import ViewProducts from './ViewProducts/ViewProducts';
import EditProduct from './EditProduct/EditProduct';
import CreateNewUser from './CreateNewUser/CreateNewUser';
import ManageUsers from './ManageUsers/ManageUsers';
import SalesRequestsManagement from './SalesRequestsManagement/SalesRequestsManagement';
import SalesCreateRequest from './SalesCreateRequest/SalesCreateRequest';
import SalesMyRequests from './SalesMyRequests/SalesMyRequests';
import HeldOrdersPage from './HeldOrdersPage/HeldOrdersPage';
import Customers from './Customers/Customers';
import CustomerProfile from './CustomerProfile/CustomerProfile';
import AddCustomer from './AddCustomer/AddCustomer';
const App = () => {
  return (
    <Router>
      <Routes>
        {/* Main entry point */}
        <Route path="/" element={<LoginPage />} />

        {/* Worker View */}
        <Route path="/worker" element={<Workers/>} />

        {/* Factory Manager View */}
        <Route path="/factory-manager" element={<FactoryManagerView />} />

        {/* Sales View */}
        <Route path="/sales" element={<SalesView />} />

        {/* Company Manager View */}
        <Route path="/company-manager" element={<CompanyManagerView />} />

        {/* Additional routes if needed */}
        <Route path="/product-management" element={<ProductManagement />} />
        <Route path="/products-inventory" element={<ProductsInventory />} />
        <Route path="/requests-management" element={<RequestsManagement />} />
        <Route path="/create-new-product" element={<CreateNewProduct />} />
        <Route path="/view-products" element={<ViewProducts />} />
        <Route path="/edit-product" element={<EditProduct />} />
        <Route path="/create-new-user" element={<CreateNewUser />} />
        <Route path="/manage-users" element={<ManageUsers />} />
        <Route path="sales-requests-management" element = {<SalesRequestsManagement />} />
        <Route path="/sales-create-request" element={<SalesCreateRequest />} />
        <Route path="/sales-my-requests" element={<SalesMyRequests />} />
        <Route path="/held-orders" element={<HeldOrdersPage />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerProfile />} />
        <Route path="/customers/new" element={<AddCustomer />} />
      </Routes>
    </Router>
  );
};

export default App;
